import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import communityApi from '../../api/communityApi';
import { KindInterface } from "../../store/community/kindsSlice";
import communityUrls from "../../configs/community/communityUrls";

const PREFIX = 'community';

const processStrategy = (value: any) => {
  return {
    ...value,
    thumbnail_url: communityUrls.remoteUrl(value.thumbnail_url)
  };
}

const kindsEntity = new schema.Entity(
  'kinds',
  {},
  {
    processStrategy
  }
);

const kindEntity = new schema.Entity(
  'kind',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      kind: KindInterface
    }
  >(response.data.kind, kindEntity);

  return normalized.entities;
}

const normalizeCollection = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      kinds: { [key: string]: KindInterface };
    }
  >(response.data.kinds, [kindsEntity]);

  return {
    kinds: normalized.entities?.kinds || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

export const fetchKinds = createAsyncThunk(
  `${PREFIX}_kinds/fetchKinds`,
  async ({ params }: { params: object }) => {
    const response = await communityApi.get(`/onesky/kinds`, { params })

    return normalizeCollection(response);
  }
);

export const fetchKind = createAsyncThunk(
  `${PREFIX}_kinds/fetchKind`,
  async (id: number) => {
    const response = await communityApi.get(`/onesky/kinds/${id}`)

    return normalizeInstance(response);
  }
);

export const createKind = createAsyncThunk(
  `${PREFIX}_kinds/createKind`,
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await communityApi.post(`/onesky/kinds`, data)

      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateKind = createAsyncThunk(
  `${PREFIX}_kinds/updateKind`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await communityApi.patch(`/onesky/kinds/${id}`, data)

      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyKind = createAsyncThunk(
  `${PREFIX}_kinds/destroyKind`,
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await communityApi.delete(`/onesky/kinds/${id}`)

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const reorderKinds = createAsyncThunk(
  `${PREFIX}_kinds/reorderKinds`,
  async ({ ids }: { ids: any }, { rejectWithValue }) => {
    try {
      await communityApi.patch('/onesky/kinds/reorder', { ids })

      return { ids };
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);
